import axios from 'axios';
export function createCEOApprovalsApi({endpoints={},sessionToken}={}) {
  const headers = sessionToken ? {Authorization:`Bearer ${sessionToken}`} : {};
  return {
    loadApprovals: endpoints.read ? async ({signal}) => (await axios.get(endpoints.read,{signal,headers,timeout:30000})).data : undefined,
    onDecision: endpoints.decide ? async (payload,{idempotencyKey}) => (await axios.post(endpoints.decide,payload,{headers:{...headers,'Idempotency-Key':idempotencyKey},timeout:30000})).data : undefined,
  };
}
